import { useTranslation } from "react-i18next";
import Reveal from "@/components/base/Reveal";
import { MAPS_DIRECTIONS_LINK, MAPS_EMBED_SRC, WHATSAPP_LINK } from "@/mocks/restaurant";

export default function Location() {
  const { t } = useTranslation();

  return (
    <section id="como-llegar" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-4xl px-5 md:px-10">
        <Reveal>
          <h2 className="text-center font-heading text-3xl leading-tight text-foreground-50 md:text-5xl">
            {t("location.title")}
          </h2>

          <p className="mt-8 text-balance text-center font-heading text-2xl leading-snug text-primary-500 md:text-3xl">
            {t("location.address")}
          </p>
          <p className="mx-auto mt-4 max-w-xl text-center font-body text-base text-secondary-500">
            {t("location.subtitle")}
          </p>

          <div className="mt-8 rounded-lg border border-primary-500 bg-background-100 p-5">
            <p className="font-body text-base leading-relaxed text-secondary-500">
              {t("location.notice")}
            </p>
          </div>

          <div className="mt-8 overflow-hidden rounded-lg border border-background-300/60">
            <iframe
              title={t("location.mapTitle")}
              src={MAPS_EMBED_SRC}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="h-[320px] w-full md:h-[420px]"
            />
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href={MAPS_DIRECTIONS_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="press inline-flex min-h-[48px] w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 font-body text-sm text-foreground-950 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-map-pin-2-line text-lg" aria-hidden="true" />
              {t("location.ctaMaps")}
            </a>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="press inline-flex min-h-[48px] w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-500 bg-transparent px-6 py-3.5 font-body text-sm text-primary-500 transition-colors hover:bg-primary-500/10 cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-lg" aria-hidden="true" />
              {t("location.ctaWhatsapp")}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}